import React from 'react';
import type { AccommodationListingDTO } from '@shared/types/Accommodations.types';
import { useTranslation } from '@shared/core';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { useAccommodationsListingMobileLayout } from '@apps/stays/AccommodationsConsole/hooks/useAccommodationsListingMobileLayout';

type CouplesPickProps = Readonly<{
  listing: AccommodationListingDTO;
  isAdmin: boolean;
  showCouplesPicksTag: boolean;
}>;

export const CouplesPick = ({ listing, isAdmin, showCouplesPicksTag }: CouplesPickProps) => {
  const { tq } = useTranslation('accommodationsConsole');

  const { isMobileOrTablet } = useAccommodationsListingMobileLayout();

  const getCouplesPickText = () => {
    if (listing.type === 'roomBlock' && isAdmin) {
      return tq`Our Room Block`;
    }
    if (listing.type === 'roomBlock') {
      return tq`Room Block`;
    }
    return showCouplesPicksTag ? tq`Couple's Pick` : null;
  };

  if (!getCouplesPickText()) {
    return null;
  }

  return (
    <Flex
      width="100%"
      justifyContent={{ _: 'flex-start', md: 'flex-end' }}
    >
      <Box
        paddingX={3}
        paddingY={1}
        borderRadius={2}
        color={'white'}
        backgroundColor={'mono14'}
      >
        <TextV2 typographyVariant={isMobileOrTablet ? 'label1' : 'label2'}>{getCouplesPickText()}</TextV2>
      </Box>
    </Flex>
  );
};
